import { Eye } from 'lucide-react';
import { useIsViewer } from '@/lib/useCanEdit';

/**
 * Thin banner shown when the current user has a read-only "viewer" seat.
 * Explains why edit controls are hidden/inert. The database (migration 0058)
 * is the authoritative boundary; this is just the UX signal.
 */
export function ViewerBanner() {
  const isViewer = useIsViewer();
  if (!isViewer) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-brand-navy/90 px-4 py-1.5 text-xs font-medium text-white"
    >
      <Eye className="h-3.5 w-3.5" />
      <span>View-only access — you can browse this workspace but not make changes.</span>
    </div>
  );
}
